import { useCallback, useEffect, useState } from 'react';
import { SociogramApi } from '@BUP/services/Axios';

// Hook que encuentra la encuesta por organización y filtra por curso
export const useGetSurveysSociogram = (user) => {
  const organization = user?.organizations;
  const organizationId = organization?.id;

  const [listState, setListState] = useState({
    isLoadingSurveySociogram: false,
    sociogram: null,
    surveySociogram: null,
    errorSurveySociogram: null,
  });

  const getData = useCallback(async () => {
    setListState((prevState) => ({
      ...prevState,
      isLoadingSurveySociogram: true,
    }));
    try {
      const { data } = await SociogramApi.get(
        `/sociograms?organizationId=${organizationId}`
      );
      const sociogram = data[0] || null;
      const surveys = data[0]?.surveys || null;
      // Filtrando encuesta por curso
      const filterSurvey = surveys?.filter(
        (survey) =>
          parseInt(survey?.courseId, 10) === parseInt(user?.courseId, 10)
      );

      const surveySociogram = filterSurvey ? filterSurvey[0] : null;
      setListState((prevState) => ({
        ...prevState,
        sociogram,
        surveySociogram,
      }));
    } catch (error) {
      console.log('useGetSurveysSociogram error', error);
      setListState((prevState) => ({
        ...prevState,
        errorSurveySociogram: error.message,
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        isLoadingSurveySociogram: false,
      }));
    }
  }, [setListState, organizationId]);

  useEffect(() => {
    getData();
  }, [getData, organizationId]);

  return {
    isLoadingSurveySociogram: listState.isLoadingSurveySociogram,
    sociogram: listState.sociogram,
    surveySociogram: listState.surveySociogram,
    errorSurveySociogram: listState.errorSurveySociogram,
  };
};
